import React from 'react'
import "./previewppd.css"

const PreviewPPD = ({ props }) => {
    function formatIndianNumber(num) {
        let numStr = num.toString();
        
        // Split into integer and decimal parts
        let [integerPart, decimalPart] = numStr.split('.');
    
        // Format the integer part using Indian numbering system
        let lastThree = integerPart.slice(-3);
        let otherNumbers = integerPart.slice(0, -3);
    
        if (otherNumbers !== '') {
            lastThree = ',' + lastThree;
        }
        let formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
        return decimalPart ? formattedInteger + '.' + decimalPart : formattedInteger;
    }

    function numberToWords(num) {
        num = Number(num)
        if (num === 0) return "Zero Rupees";

        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const teens = ["Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const thousands = ["", "Thousand", "Lakh", "Crore"];

        function convertChunk(n) {
            let str = "";
            if (n >= 100) {
                str += ones[Math.floor(n / 100)] + " Hundred ";
                n %= 100;
            }
            if (n >= 11 && n <= 19) {
                str += teens[n - 11] + " ";
            } else {
                str += tens[Math.floor(n / 10)] + " ";
                str += ones[n % 10] + " ";
            }
            return str.trim();
        }

        let parts = [];
        let chunkIndex = 0;

        while (num > 0) {
            let chunk = num % (chunkIndex === 0 ? 1000 : 100);
            if (chunk > 0) {
                parts.push(convertChunk(chunk) + " " + thousands[chunkIndex]);
            }
            num = Math.floor(num / (chunkIndex === 0 ? 1000 : 100));
            chunkIndex++;
        }

        return parts.reverse().join(" ").trim();
    }

    function formatDate(inputDate) {
        if(!inputDate) return "__________"
        const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
        if (regex.test(inputDate)){
            return inputDate
        }
        const [year, month, day] = inputDate.split("-");
        return `${month}-${day}-${year}`;
    }

    return (
        <>
            <div className="page-body">
                <div className="page-info">
                    <strong>DRDO.DM.06</strong> <br />
                    <span>Page No. 1/2</span>
                </div>

                <div className="page-header">(Name of the Lab/Est.)<br /> PETTY PURCHASE DEMAND</div>

                <table className="demand-info">
                    <tbody>
                        <tr>
                            <td>MMG Demand Control No.: DRDO/MRSAM/PPD/{props.serial_no}</td>
                            <td>Div. Demand No.: MRSAM/DN/{props.serial_no}</td>
                        </tr>
                        <tr>
                            <td>Group/Division: MRSAMARMY</td>
                            <td>Div. Demand Date.: {formatDate(props.division_demand_date) || "_____________"}</td>
                        </tr>
                        <tr>
                            <td>Project/Build-up: {props.project_build_up || "_______________"}</td>
                            <td>Inventory Control Code (ICC):{props.inventory_control_code || "____________"}</td>
                        </tr>
                        <tr>
                            <td>Project Name & NO. {props.project_name_no || "_______________"}</td>
                            <td>Project PDC: {props.project_pdc || "_____________"}</td>
                        </tr>
                        <tr>
                            <td>FBE Reference: {props.fbe_reference || "_____________"}</td>
                            <td>Unit Code: {props.unit_code || "____________"}</td>
                        </tr>
                        <tr>
                            <td>Major Head: {props.major_head || " __________"}    <span style={{ paddingLeft: "50px" }}>Minor Head: {props.minor_head || "_________"} </span></td>
                            <td>Code Head: {props.code_head || "__________"}</td>
                        </tr>
                    </tbody>
                </table>
                <p>The following stores/services are to be procured through cash purchase to meet requirements as supply of these stores/services through normal purchase process cannot be awaited. Approval of the CFA may kindly be accorded.</p>
                <table className="demand-item">
                    <thead>
                        <tr>
                            <th>Sl. No</th>
                            <th>Nomenclature/ Description</th>
                            <th>Unit of Measure</th>
                            <th>Service</th>
                            <th>QTY</th>
                            <th>Estimated Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.nomenclatures.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}.</td>
                                <td>{item.nomenclature || "________________"}</td>
                                <td>{item.unit || "___________"}</td>
                                <td>{item.service || "______"}</td>
                                <td>{item.quantity || "______"}</td>
                                <td>{formatIndianNumber(item.cost) || "_________"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>Total amount for which sanction is required (inclusive of taxes): Rs. {formatIndianNumber(props.total_amount) || "_____________"}</p>
                <hr className='hr-border' />
                <p>Justification: {props.justification || "________________"}</p>
                <div className='float-left'>
                    <p> (__________)<br />
                        Initiating Officer <br />
                        Phone:__________<br />
                        Date:___________
                    </p>

                </div>
                <div className='float-right'>
                    <p>{props.hod_group_head_name || "(______________)"} <br />
                        HOD/Group Head <br />
                        Phone: {props.hod_group_head_phone || "__________"}<br />
                        Date: {props.hod_group_head_date || "__________"}
                    </p>
                </div>
                <div className='clear-both'></div>
                <hr className='hr-border' />
                <p>Items Available/Not Available in stock (not applicable for Services)</p>
                <div className='float-left'>
                    <p>
                        Phone: {props.stores_officer_phone || "__________"}<br />
                        Date: {formatDate(props.stores_officer_date) || "__________"}
                    </p>

                </div>
                <div className='float-right text-center'>
                    <p>{props.stores_officer_name || "(______________)"} <br />
                        Stores Officer
                    </p>
                </div>
                <div className='clear-both'></div>
                <hr className='hr-border' />
                <p>Certified that Funds are Available/Not Available under Budget Head {props.budget_head || "____________________"}</p>
                <div className='float-left'>
                    <p>
                        Phone: {props.budget_ic_phone || "__________"}<br />
                        Date: {props.budget_ic_date || "__________"}
                    </p>

                </div>
                <div className='float-right text-center'>
                    <p>{props.budget_ic_name || "(______________)"} <br />
                        Budget I/C
                    </p>
                </div>
                <div className='clear-both'></div>
            </div>

            <div className="page-break"></div>

            <div className="page-body">
                <div className="page-info">
                    <strong>DRDO.DM.06</strong><br />
                    <span>Page No. 2/2</span>
                </div>
                <p>MMG Demand Control No. DRDO/MRSAM/PPD/{props.serial_no}</p>
                <p>Local Purchase/Out station purchase approved and Cash Officer is authorised to pay sanctioned amount of Rs. {formatIndianNumber(props.total_amount) || "_________"} (Rupees {numberToWords(props.total_amount) || "__________________________"} Only) in {props.payment_method.toLowerCase()} by Cash Purchase Designation.<br />
                    Officer Shri {props.cash_purchase_officer_name || "______________"} Designation {props.cash_purchase_officer_designation || "__________"} whose specimen signatures are attested below.</p>
                <p>1. {props.specimen1 || "_______________"} 2. {props.specimen2 || "______________________"} 3. {props.specimen3 || "_______________________"}</p>
                <p>Altematively payment may be made by ECS / RTGS.</p>
                <p className="float-right text-center">
                    (______________________)<br />
                    CFA/Authorised Signatory.
                </p>
                <div className="clear-both"></div>
                <hr className='hr-border' />
                <p className="text-center"><strong>Receipt</strong></p>
                <p>Received Rs. {formatIndianNumber(props.total_amount) || "_________"} (Rupees {numberToWords(props.total_amount) || "__________________________"} Only) from Cash Officer for the purchase mentioned above on ( Date ): {formatDate(props.receipt_date) || "________"} in {props.payment_method.toLowerCase()}.</p>
                <p className="float-right text-center">
                    {props.cash_purchase_officer_name || "(___________________)"}<br />
                    Cash Purchase Officer.
                </p>
                <div className="clear-both"></div>
                <hr className='hr-border' />
                <p className="text-center"><strong>Certificate</strong></p>
                <p>It is Certificated that :-</p>
                <ol>
                    <li>Verbal enquiries were made and the prices paid are the cheapest/reasonable.</li>
                    <li>We {props.certifying_officers || "_________________________"} are jointly and individually satisfied that the goods/services purchased are of requisite quality and specifications and have been purchased from a reliable source/service provider at a reasonable price.</li>
                </ol>

                <p className="float-left text-center">
                    (_______________)<br />
                    Member.
                </p>

                <p className="float-right text-center">
                    {props.cash_purchase_officer_name || "(___________________)"}<br />
                    Cash Purchase Officer.
                </p>
                <div className="clear-both"></div>
                <hr className='hr-border' />
                <p className="text-center"><strong>Settlement</strong></p>
                <p>Received balance amount of Rs. {formatIndianNumber(props.total_amount) || "_________"} (Rupees {numberToWords(props.total_amount) || "__________________________"} Only) from Shri {props.cash_officer_name || "___________"} Designation: {props.cash_officer_designation || "____________"} on {formatDate(props.settlement_date) || "__________ ( date )"} with two copies
                    of cash memo and receipt voucher. The advance drawn by the Officer has been settled without any discrepancy. Actual expenditure incurred is Rs. {formatIndianNumber(props.total_amount) || "_________"} (Rupees {numberToWords(props.total_amount) || "__________________________"} Only) and the DV No. is {props.dv_no || "______"}.</p>
                {props.settlement_payment_method === "Cheque" ?
                    <p>Cheque No. {props.cheque_no || "____________"} dated {formatDate(props.settlement_date) || "_________"} Amount (Rs.):{formatIndianNumber(props.total_amount) || "_________"} issued</p>
                    :
                    <p>ESC / RTGS payment for Rs. {formatIndianNumber(props.total_amount) || "_________"} made on date {formatDate(props.settlement_date) || "_________"}</p>
                }

                <p className="float-left text-center">
                    Date: {formatDate(props.settlement_date)}
                </p>

                <p className="float-right text-center">
                    {props.cash_officer_name || "(________________)"}<br />
                    Cash Officer
                </p>
                <div className="clear-both"></div>
            </div>
        </>
    )
}

export default PreviewPPD;